import React from 'react';
import axios from 'axios';
import { Message, Form, Button, Segment, List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { PANELCHANGER_BASEURL } from '../../constants/system';
import { validatePassword, PASSWORD_REQUIREMENTS_TEXT } from '../../utils/passwordPolicy';

/**
 * Password reset page. User arrives via email link: /reset-password?token=...
 * Submits new password + confirmation to backend.
 */
export default class ResetPassword extends React.Component {

	state = {
		password: '',
		confirmPassword: '',
		loading: false,
		success: false,
		error: null
	};

	getTokenFromLocation() {
		const search = this.props.location && this.props.location.search ? this.props.location.search : '';
		const params = new URLSearchParams(search);
		return params.get('token') || '';
	}

	handleSubmit = () => {
		const token = this.getTokenFromLocation();
		if (!token) {
			this.setState({ error: 'Érvénytelen vagy hiányzó link. Kérd újra a jelszó visszaállítását.' });
			return;
		}
		const password = (this.state.password || '').trim();
		const confirmPassword = (this.state.confirmPassword || '').trim();
		if (!password) {
			this.setState({ error: 'Add meg az új jelszót.' });
			return;
		}
		const validation = validatePassword(password);
		if (!validation.valid) {
			this.setState({ error: 'A jelszónak meg kell felelnie a követelményeknek: ' + validation.errors.join(' ') });
			return;
		}
		if (password !== confirmPassword) {
			this.setState({ error: 'A két jelszó nem egyezik.' });
			return;
		}
		this.setState({ loading: true, error: null });
		axios({
			url: PANELCHANGER_BASEURL + '/reset-password',
			method: 'post',
			data: { token, password },
			timeout: 20000
		})
			.then(() => this.setState({ loading: false, success: true }))
			.catch((err) => {
				const msg = err.response && err.response.data
					? (typeof err.response.data === 'string' ? err.response.data : (err.response.data.message || JSON.stringify(err.response.data)))
					: err.message;
				this.setState({ loading: false, error: msg || 'Kérjük, próbáld később.' });
			});
	};

	render() {
		const token = this.getTokenFromLocation();

		if (!token) {
			return (
				<div>
					<Segment padded="very">
						<Message error>Érvénytelen vagy hiányzó jelszó-visszaállítási link. Kérd újra az e-mailt az Elfelejtett jelszó menüpontból.</Message>
						<Link to="/"><Button primary>Vissza a bejelentkezéshez</Button></Link>
					</Segment>
				</div>
			);
		}

		if (this.state.success) {
			return (
				<div>
					<Segment padded="very">
						<Message success>Az új jelszavad beállítva. Most már bejelentkezhetsz.</Message>
						<Link to="/"><Button primary>Belépés</Button></Link>
					</Segment>
				</div>
			);
		}

		return (
			<div>
				<Segment padded="very" loading={this.state.loading}>
					<div className="app-logo-block">
						<img alt="" src="/sxtlogo2.png" className="app-logo-img" />
						<span className="app-logo-text">SLR Light</span>
					</div>
					<br /><br />
					<h3>Új jelszó megadása</h3>
					<Message info style={{ maxWidth: '400px' }}>
						<Message.Header>Jelszókövetelmények</Message.Header>
						<p style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>Az új jelszónak teljesítenie kell:</p>
						<List size="small" bulleted>
							{PASSWORD_REQUIREMENTS_TEXT.map(function (text, i) { return <List.Item key={i}>{text}</List.Item>; })}
						</List>
					</Message>
					{this.state.error && <Message error>{this.state.error}</Message>}
					<Form style={{ maxWidth: '300px' }}>
						<Form.Field>
							<label>Új jelszó</label>
							<input
								type="password"
								placeholder="Jelszó"
								value={this.state.password}
								onChange={(e) => this.setState({ password: e.target.value })}
							/>
						</Form.Field>
						<Form.Field>
							<label>Jelszó megerősítése</label>
							<input
								type="password"
								placeholder="Ismételd meg a jelszót"
								value={this.state.confirmPassword}
								onChange={(e) => this.setState({ confirmPassword: e.target.value })}
							/>
						</Form.Field>
						<Button onClick={this.handleSubmit} primary>Jelszó mentése</Button>
						<Link to="/" style={{ marginLeft: '0.5rem' }}>Mégse</Link>
					</Form>
				</Segment>
				<div className="splashfooter">
					<center>
						<small style={{ color: '#555' }}>
							{window.document.title}<br />
							&copy; 2019 - 2026
						</small>
					</center>
				</div>
			</div>
		);
	}
}
